(() => {
  const headerGroup = document.querySelector('.shopify-section-group-header-group');
  const updateHeader = () => headerGroup?.classList.toggle('mm-header-scrolled', window.scrollY > 16);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  const categoryLinks = Array.from(document.querySelectorAll('.mm-discovery-bar__link'));
  const currentUrl = new URL(window.location.href);
  const currentCategory = categoryLinks.find((link) => {
    const target = new URL(link.href, window.location.origin);
    if (target.pathname !== currentUrl.pathname) return false;
    return Array.from(target.searchParams.entries()).every(([key, value]) => currentUrl.searchParams.get(key) === value);
  });
  if (currentCategory) {
    categoryLinks.forEach((link) => {
      link.classList.remove('mm-discovery-bar__link--primary', 'mm-discovery-bar__link--current');
      link.removeAttribute('aria-current');
    });
    currentCategory.classList.add('mm-discovery-bar__link--current');
    currentCategory.setAttribute('aria-current', 'page');
  }


})();

(() => {
  class MMBannerCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.slides = Array.from(this.querySelectorAll('[data-mm-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-mm-dot]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => slide.getAttribute('aria-hidden') === 'false'));
      this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.autoRotate = this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.userPaused = false;
      this.interactionPaused = false;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.querySelector('[data-mm-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-mm-next]')?.addEventListener('click', () => this.step(1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.show(Number(dot.dataset.index), true)));
      this.toggle = this.querySelector('[data-mm-toggle]');
      this.toggle?.addEventListener('click', () => this.togglePlayback());
      this.addEventListener('mouseenter', () => this.pauseForInteraction());
      this.addEventListener('mouseleave', () => this.resumeAfterInteraction());
      this.addEventListener('focusin', () => this.pauseForInteraction());
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.resumeAfterInteraction();
      });
      this.handleVisibility = () => document.hidden ? this.stop() : this.start();
      this.handleBlockSelect = (event) => {
        const slideIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (slideIndex >= 0) this.show(slideIndex);
      };
      document.addEventListener('visibilitychange', this.handleVisibility);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.show(this.index);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.handleVisibility);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    show(nextIndex, restart = false) {
      this.index = (nextIndex + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const current = index === this.index;
        slide.hidden = !current;
        slide.setAttribute('aria-hidden', String(!current));
      });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      if (restart) {
        this.stop();
        this.start();
      }
    }

    step(direction) {
      this.show(this.index + direction, true);
    }

    start() {
      if (!this.autoRotate || this.userPaused || this.interactionPaused || document.hidden || this.timer) return;
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    pauseForInteraction() {
      this.interactionPaused = true;
      this.stop();
    }

    resumeAfterInteraction() {
      this.interactionPaused = false;
      this.start();
    }

    togglePlayback() {
      this.userPaused = !this.userPaused;
      const pauseIcon = this.toggle?.querySelector('[data-mm-pause]');
      const playIcon = this.toggle?.querySelector('[data-mm-play]');
      if (pauseIcon) pauseIcon.hidden = this.userPaused;
      if (playIcon) playIcon.hidden = !this.userPaused;
      if (this.toggle) {
        this.toggle.setAttribute('aria-label', this.userPaused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
      }
      if (this.userPaused) this.stop(); else this.start();
    }
  }

  if (!customElements.get('mm-banner-carousel')) customElements.define('mm-banner-carousel', MMBannerCarousel);
})();
